import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { AuthLayout } from "../components/AuthLayout";
import { Button, Field, Input, Alert, Spinner } from "../components/ui";

export function VerifyPage() {
  const { verify, resend } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const stateEmail = location.state?.email || "";
  const devCode = location.state?.devCode;

  const [email, setEmail] = useState(stateEmail);
  const [code, setCode] = useState("");
  const [error, setError] = useState("");
  const [notice, setNotice] = useState(
    devCode ? `Dev mode: your code is ${devCode}` : ""
  );
  const [busy, setBusy] = useState(false);

  async function onSubmit(e) {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      await verify({ email, code });
      navigate("/gear");
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  }

  async function onResend() {
    setError("");
    setNotice("");
    try {
      const res = await resend(email);
      setNotice(res.devCode ? `Dev mode: your new code is ${res.devCode}` : res.message || "Code sent.");
    } catch (err) {
      setError(err.message);
    }
  }

  return (
    <AuthLayout
      title="Check your email"
      subtitle="Enter the 6-digit code we sent to verify your account."
      footer={
        <Link to="/gear/login" className="text-brand-600 font-semibold hover:underline">
          Back to sign in
        </Link>
      }
    >
      <form onSubmit={onSubmit} className="space-y-4">
        {!stateEmail && (
          <Field label="Email">
            <Input
              type="email"
              required
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="you@example.com"
            />
          </Field>
        )}
        <Field label="Verification code">
          <Input
            inputMode="numeric"
            pattern="[0-9]*"
            maxLength={6}
            required
            value={code}
            onChange={(e) => setCode(e.target.value.replace(/\D/g, ""))}
            placeholder="123456"
            className="text-center text-2xl tracking-[0.5em] font-semibold"
          />
        </Field>
        {notice && <Alert kind="info">{notice}</Alert>}
        <Alert>{error}</Alert>
        <Button type="submit" disabled={busy} className="w-full">
          {busy ? <Spinner /> : "Verify & continue"}
        </Button>
        <button
          type="button"
          onClick={onResend}
          className="w-full text-sm text-slate-500 hover:text-brand-600"
        >
          Didn't get it? Resend code
        </button>
      </form>
    </AuthLayout>
  );
}
